var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"roadmap-point",style:({ top: _vm.level.position.y + 'px', left: _vm.level.position.x + 'px' })},[_c('img',{staticClass:"point-icon",attrs:{"src":_vm.level.img,"alt":"level-image"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }